import { Component, Injectable } from '@angular/core';
import { DispatcherModule } from '../dispatcher.module';
import { NgRedux } from '@angular-redux/store';
import { AppState } from '../state.model';
import { UpdateActions } from './update-actions';

@Injectable({
  providedIn: DispatcherModule,
})
export class UpdateDispatcher {
  /**
  * @require ngRedux Redux
  * @require azureService MSAL azure library
  **/
  constructor(
    private ngRedux: NgRedux<AppState>
  ) { }

  /**
  * @functions setUpdateInfo Store the update info
  * @param isUpdated
  * @return void
  **/
  public setUpdateInfo(isUpdated: string) {
    this.ngRedux.dispatch(UpdateActions.setUpdateInfo(isUpdated));
  }
  /**
  * @method resetUpdate reset the update info
  * @return void
  **/
  public resetUpdate(): void {
    this.ngRedux.dispatch(UpdateActions.resetUpdate());
  }

}
